import { memo, useState, useCallback, useRef } from 'react';
import { useOnComponentMount } from '../../../hooks/use-on-component-mount';

export const ResizeObserverWrapper = memo(({ children }) => {
  const [bottom, setBottom] = useState(null);
  const [height, setHeight] = useState(null);
  const [left, setLeft] = useState(null);
  const [right, setRight] = useState(null);
  const [top, setTop] = useState(null);
  const [width, setWidth] = useState(null);
  const [x, setX] = useState(null);
  const [y, setY] = useState(null);
  const ref = useRef();
  const resizeObserver = useRef();
  const requestAnimationFrame = useRef();

  const updateFromDOMRect = useCallback((rect) => {
    if (!requestAnimationFrame.current) {
      requestAnimationFrame.current = window.requestAnimationFrame(() => {
        requestAnimationFrame.current = null;
        setBottom(rect.bottom);
        setHeight(rect.height);
        setLeft(rect.left);
        setRight(rect.right);
        setTop(rect.top);
        setWidth(rect.width);
        setX(rect.x);
        setY(rect.y);
      });
    }
  }, []);

  useOnComponentMount(() => {
    resizeObserver.current = new ResizeObserver((entries) => {
      const [entry] = entries;

      updateFromDOMRect(entry.contentRect);
    });
    resizeObserver.current.observe(ref.current);

    return () => {
      resizeObserver.current?.disconnect();

      if (requestAnimationFrame.current) {
        window.cancelAnimationFrame(requestAnimationFrame.current);
      }
    };
  });

  return children({
    bottom,
    height,
    left,
    right,
    top,
    width,
    x,
    y,
    ref,
  });
});
